export default __webpack_public_path__ + "static/media/17.73f7bdf6.jpg";